import Swiper from "./swiper-bundle.esm.browser.min.js";
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.announcementBar = this.querySelector("#wt-announcement__container");
    this.announcementInterval = null;
    this.swiper = null;
    this.resizeHandler = this.handleResize.bind(this);

    this.changeAnnouncement = this.changeAnnouncement.bind(this);
    this.previousAnnouncement = this.previousAnnouncement.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.hideForOneDay = this.hideForOneDay.bind(this);
    this.restartInterval = this.restartInterval.bind(this);
    this.isMobileView = this.isMobileView.bind(this);
  }

  connectedCallback() {
    if (!this.announcementBar) return;

    const isMarquee = this.announcementBar.classList.contains(
      "wt-announcement__container--marquee",
    );
    const isSlideshow = this.announcementBar.classList.contains(
      "wt-announcement__container--slideshow",
    );

    if (isSlideshow) {
      this.initializeSlideshow();
    } else if (!isMarquee) {
      this.announcementInterval = setInterval(this.changeAnnouncement, 5000);

      this.announcementBar.addEventListener(
        "touchstart",
        this.handleTouchStart,
        { passive: true },
      );
      this.announcementBar.addEventListener(
        "touchmove",
        this.handleTouchMove,
        { passive: true },
      );
      this.announcementBar.addEventListener(
        "touchend",
        this.handleTouchEnd,
        { passive: true },
      );
      this.announcementBar.addEventListener(
        "touchstart",
        this.pauseInterval,
        { passive: true },
      );
      this.announcementBar.addEventListener(
        "touchend",
        this.restartInterval,
        { passive: true },
      );

      this.announcementBar.style.transition = "transform 0.5s ease-in-out";
    }

    this.closeButton = this.querySelector(".wt-announcement__close");
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.hideForOneDay);
    }

    window.addEventListener("resize", this.resizeHandler);
  }

  initializeSlideshow() {
    if (typeof Swiper === "undefined" || !this.announcementBar) return;

    const slideCount = this.announcementBar.querySelectorAll(".swiper-slide").length;
    const prevButton = this.querySelector(".wt-announcement__slider-button--prev");
    const nextButton = this.querySelector(".wt-announcement__slider-button--next");

    this.swiper = new Swiper( this.announcementBar, {
      slidesPerView: 1,
      loop: slideCount > 1,
      allowTouchMove: false,
      simulateTouch: false,
      grabCursor: false,
      autoplay: false,
      autoHeight: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
    });
  }

  handleResize() {
    const isSlideshow = this.announcementBar?.classList.contains(
      "wt-announcement__container--slideshow",
    );

    if (isSlideshow) {
      this.swiper?.update();
      return;
    }

    if (window.innerWidth >= 900) {
      if (this.announcementBar) {
        this.announcementBar.style.transform = "translateX(0)";
        this.currentIndex = 0;
      }
    }
  }

  isMobileView() {
    return window.innerWidth < 900;
  }

  pauseInterval = () => {
    clearInterval(this.announcementInterval);
  };

  restartInterval() {
    clearInterval(this.announcementInterval);
    this.announcementInterval = setInterval(this.changeAnnouncement, 5000);
  }

  hideForOneDay() {
    const oneDayLater = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem("wt-announcement-hidden", oneDayLater);
    this.style.display = "none";
  }

  changeAnnouncement() {
    if (!this.isMobileView() || !this.announcementBar) {
      return;
    }

    const totalSlides = this.announcementBar.children.length;
    if (!totalSlides) return;

    this.currentIndex = (this.currentIndex + 1) % totalSlides;
    const newPosition = -(this.currentIndex * 100);

    this.announcementBar.style.transform = `translateX(${newPosition}vw)`;

    if (this.currentIndex === 0) {
      setTimeout(() => {
        this.announcementBar.style.transition = "none";
        this.announcementBar.style.transform = "translateX(0)";
        this.currentIndex = 0;

        setTimeout(() => {
          this.announcementBar.style.transition = "transform 0.5s ease-in-out";
        }, 0);
      }, 490);
    }
  }

  previousAnnouncement() {
    if (!this.announcementBar) return;

    const totalSlides = this.announcementBar.children.length;
    if (!totalSlides) return;

    this.currentIndex = (this.currentIndex - 1 + totalSlides) % totalSlides;
    const newPosition = -(this.currentIndex * 100);
    this.announcementBar.style.transform = `translateX(${newPosition}vw)`;
  }

  handleTouchStart(e) {
    if (this.isMobileView()) {
      this.touchStartX = e.touches[0].clientX;
    }
  }

  handleTouchMove(e) {
    if (this.isMobileView()) {
      this.touchEndX = e.touches[0].clientX;
    }
  }

  handleTouchEnd() {
    const swipeThreshold = 30;

    if (Math.abs(this.touchEndX - this.touchStartX) > swipeThreshold) {
      if (this.touchEndX < this.touchStartX) {
        this.changeAnnouncement();
      } else {
        this.previousAnnouncement();
      }
    }
  }

  disconnectedCallback() {
    clearInterval(this.announcementInterval);

    if (this.announcementBar) {
      this.announcementBar.removeEventListener(
        "touchstart",
        this.handleTouchStart,
      );
      this.announcementBar.removeEventListener(
        "touchmove",
        this.handleTouchMove,
      );
      this.announcementBar.removeEventListener(
        "touchend",
        this.handleTouchEnd,
      );
      this.announcementBar.removeEventListener(
        "touchstart",
        this.pauseInterval,
      );
      this.announcementBar.removeEventListener(
        "touchend",
        this.restartInterval,
      );
    }

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    window.removeEventListener("resize", this.resizeHandler);
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define("announcement-bar", AnnouncementBar);
}